<template>
    <div :class="fix?'header header-fix':'header'">
        <div class="bot">
            <div id="tsa-pc-navigation"></div>
        </div>
    </div>
</template>

<script>
import { navContent } from './config/navContent'
import moment from "moment";
import 'tsa-components-umd/dist/tsa-components-umd.min.css'
const TsaComponentsUmd = require('tsa-components-umd')
export default {
    name: 'tsa-header',
    props: {
        currentTime:{
            type: Number,
            default:() => {
                return null
            },
        },
        navContent: {
            type: Object,
            default: () => {
                return {}
            }
        },
        userInfo: {
            type: Object,
            default: () => {
                return {}
            }
        },
        userMenu:{
            type: Array,
            default: () => {
                return []
            }
        },
        messageInfo:{
            type: Object,
            default: () => {
                return {
                    showRead:false,
                    link:process.env.VUE_APP_ACCOUNTUI+'/messageCenter/history?clientId=700012'
                }
            }
        }
    },
    data() {
        return {
            fix:false,
            winScroll:'',
            time: "国家授时中心标准时间",
            utc: "",
            timer: null,
            deviceType:'big'
        };
    },
    components: {},
    watch: {
        currentTime: {
            handler(newValue) {
                if(newValue){
                    this.currentTime = newValue;
                    clearInterval(this.timer);
                    this.timer = null;
                }
            },
            immediate: true
        }
    },
    computed: {
        VUE_APP_TSAPLUS(){
            return process.env.VUE_APP_TSAPLUS
        },
        navLink:{
            get(){
                if(JSON.stringify(this.navContent) == "{}"){
                    return navContent;
                }else{
                    return this.navContent;
                }
            },
			set(value){} 
        } 
    },
    created() {
    },
    mounted() {
        clearInterval(this.timer)
        this.timer = null;
        window.removeEventListener('scroll', this.scroll);
        window.addEventListener("scroll", this.scroll);
        window.addEventListener('resize', this.resize)
        let that = this
        this.$nextTick(() => {
            TsaComponentsUmd.pcNavigation({
                type: 'ipr',
                el: '#tsa-pc-navigation',
                env: process.env.VUE_APP_ENV,
                internationalization: true,
                language: this.$i18n.locale, // en
                clientId: "952310",
                currentPath: process.env.VUE_APP_COPYRIGHT,
                logo: "https://tsa-content.oss-cn-beijing.aliyuncs.com/logo/ipr_whole_dark_logo.png",
                title: "可信时间戳知识产权保护平台",
                seoTitle: "可信时间戳知识产权保护平台",
                onLanguageChange (val) {
                    that.changeLang()
                }
            })
        })
    },
    deactivated () {
        clearInterval(this.timer);
        this.timer = null;
        window.removeEventListener('scroll', this.scroll)
    },
    beforeDestroy () {
        clearInterval(this.timer)
        this.timer = null
        window.removeEventListener('scroll', this.scroll)
    },
    methods: {
        changeLang(){
            if(this.$i18n.locale=='zh'){
                this.$i18n.locale='en'
                this.$setlocalStorage('language','en')
            }else{
                this.$i18n.locale='zh'
                this.$setlocalStorage('language','zh')
            }
            TsaComponentsUmd.toggleLang(this.$i18n.locale);
        },
    }
};
</script>

<style src="./css/header.less" lang="less" scoped></style>
